import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsPA: CultureInfo = {
  name: 'es-PA',
  displayName: 'Spanish (Panama)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-PA',
  parent: CultureInfoEs
};
